<!-- Floating Support Button -->
@if (!isOpen && showSupportButton) {
  <button
    (click)="toggleChat()"
    class="support-chat-floating-button"
    aria-label="Open support chat"
    [ngStyle]="{
      position: isMobile && 'fixed',
      bottom: isMobile && '5rem',
      right: isMobile && '0.5rem',
    }"
  >
    <img
      src="assets/icons/chat.svg"
      alt="Ask pipa"
      class="support-chat-floating-button__image"
      draggable="false"
    />
  </button>
}

<!-- Support Chat Container -->
@if (isVisible) {
  <div
    class="support-chat-animated"
    [ngClass]="{ expanded: isExpanded }"
    [@slideInOut]="isOpen ? 'in' : 'out'"
    (@slideInOut.done)="onAnimationDone($event)"
  >
    <!-- Support Chat Header -->
    <div class="support-chat-header flex__row--space-between">
      <div class="support-chat-header__greeting">
        <img
          class="support-chat-header__logo"
          src="/assets/images/pipa_headshot.svg"
          alt="Support Avatar"
          draggable="false"
        />
        <span class="support-subtitle"
          >Hey {{ userFirstName }}, what's on your mind?</span
        >
      </div>
      <div class="support-chat-header__actions">
        <div
          class="support-chat-header__support-btn"
          (click)="toggleExpand()"
          aria-label="Expand/minimize support chat"
        >
          @if (!isExpanded) {
            <img
              src="assets/icons/expand.svg"
              alt="Expand"
              class="support-chat-header__expand-icon"
              draggable="false"
            />
          }
          @if (isExpanded) {
            <img
              src="assets/icons/minus.svg"
              width="24"
              alt="Minimize"
              draggable="false"
            />
          }
        </div>
        <div
          class="support-chat-header__support-btn"
          (click)="closeChat()"
          aria-label="Close support chat"
        >
          <img
            src="assets/icons/x-close-white.svg"
            alt="X"
            draggable="false"
            width="28"
            height="28"
          />
        </div>
      </div>
    </div>
    <!-- Topic Buttons (only show if user hasn't sent any messages this session) -->
    @if (showTopics && !isExpanded) {
      <div class="support-topic-buttons">
        <app-button
          label="Is my linkedin session active?"
          (click)="
            sendSupportMessageFromTopic('Is my linkedin session active?')
          "
          class="dark"
          aria-label="Is my linkedin session active?"
        ></app-button>
        <p class="support-topic-buttons__help-text">
          Click on a topic or type your question
        </p>
      </div>
    }
    <!-- Chat Body -->
    <div
      id="chat"
      #chatBody
      class="support-chat-body"
      [ngClass]="{ 'body-expanded': isExpanded }"
    >
      <stream-channel>
        <stream-message-list></stream-message-list>
        <stream-notification-list></stream-notification-list>
        <stream-thread name="thread">
          <stream-message-list mode="thread"></stream-message-list>
          <!-- <stream-typing-indicator mode="thread"></stream-typing-indicator> -->
        </stream-thread>
      </stream-channel>
    </div>
    <!-- Support Chat Footer -->
    <div class="support-chat-footer" [ngClass]="{ expanded: isExpanded }">
      @if (isThreadOpen) {
        <div>
          <p class="support-chat-footer__disclaimer">
            pipa is here to answer all of your questions.
          </p>
          <stream-channel>
            <stream-message-input></stream-message-input>
            <stream-thread name="thread">
              <stream-message-input mode="thread"></stream-message-input>
            </stream-thread>
          </stream-channel>
        </div>
      }
    </div>
  </div>
}
